<!-- OrderDetailBody.vuefield-line -->
<template>
  <div class="page">
    <gobuy-head title="Card Details" />
    <div class="zhanweifu" style="height: 4.2rem;" v-if="!$IFR.is_iframe"></div>
    <div class="order-body">
      <div class="texts">
        <img src="../../../assets/image/vipt.jpg"/>
        <div class="h2">{{ $t('High Priced Recycling') }} 100%</div>
      </div>
      <div class="main-content">
        <flex-line class="field-line" :show-border="true">
          <div class="field-name">{{ $t("Card number") }}</div>
          <div class="field-line-right" slot="right">
            <div v-if="bind_flag">{{ save_info.card }}</div>
            <input class="field-input" v-model="save_info.card" :placeholder="$t('Please enter the card number')"
              @blur="bind" v-else />
            <div class="edit" v-if="bind_flag" @click="bind_flag = false">
              Edit
            </div>
          </div>
        </flex-line>
        <flex-line class="field-line" :show-border="true">
          <span class="field-name">{{ $t("Activation code") }}</span>
          <div class="field-line-right" slot="right">
            <input class="field-input" v-model="save_info.code" :placeholder="$t('Please enter the activation code')" />
          </div>
        </flex-line>
        <div v-if="save_info.type != 1">
          <div class="btn1" @click="goAccountGold">Gold Card Balance: {{gold_card_balance}}</div>
          <div class="gold-w" @click="doWithdraw">Withdraw Gold Card Balance >></div>
        </div>
      </div>
      <div class="common-btn ds-button-large mt-5" @click="giftSave" style="margin-bottom: 200px;">
        {{ $t("Confirm Recycling") }}
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, MessageBox } from "mint-ui";
import { BindGift, GiftSave, GoldCardSave } from "../../../api/memberOrder";
import flexLine from "../../flexLine";
import { getMemberIndex } from '../../../api/member'

export default {
  name: "MemberOrderDetail",
  data() {
    return {
      order_info: {},
      rec_id: 0,
      popupRefund: false,
      save_info: {
        card: "",
        code: "",
      },
      bind_flag: false,
      gold_card_balance: '0.00',
      next_withdraw_time: 0,
    };
  },
  components: {
    flexLine,
  },
  created: function () {
    const urlParams = new URLSearchParams(window.location.search);
    this.save_info.card = urlParams.get('number')
    this.save_info.code = urlParams.get('code')
    this.save_info.type = urlParams.get('type')
    this.getGoldCardBalance()
  },
  methods: {
    goAccountGold(){
      this.$router.push({ name: 'MemberAccountGold'} )
    },
    doWithdraw(){
      if(this.next_withdraw_time != 0){
        Toast({
          message: `Next withdrawal time\n\n${this.next_withdraw_time}`,
          className: 'toast-multiline',
          duration: 2000
        })
        return;
      }
      this.$router.push({ name: 'GoldBalanceWithdrawList'} )
    },
    getGoldCardBalance() {
      getMemberIndex().then(response => {
        if (response && response.result.member_info) {
          const info = response.result.member_info
          this.gold_card_balance = info.gold_card_balance
          this.next_withdraw_time = info.gold_withdraw_time
        }
      })
    },
    bind() {
      if (this.save_info.card == "") return;
      BindGift(this.save_info.card).then((res) => {
        if (res.code == 10000) {
          this.bind_flag = true;
        } else {
          Toast(res.message);
          this.save_info.card = "";
        }
      });
    },
    giftSave() {
      let that = this;
      if (that.save_info.card === "") {
        Toast(that.$t("Please enter the card number"));
        return;
      }
      if (that.save_info.code === "") {
        Toast(that.$t("Please enter the activation code"));
        return;
      }
      const msg = that.save_info.type == 2 ? "Are you sure you want to recycle this gold card?" : "Are you sure you want to recycle this gift card?";
      MessageBox({
        title: that.$t("MessageBox.Tips"),
        message: msg,
        confirmButtonText: that.$t("MessageBox.Confirm"),
        cancelButtonText: that.$t("MessageBox.Cancel"),
        showCancelButton: true,
      }).then((action) => {
        if (action == "confirm") {
          const api = that.save_info.type == 2 ? GoldCardSave : GiftSave
          api(that.save_info.card, that.save_info.code).then((res) => {
              Toast(res.message);
              if (res.code == 10000) {
                if(that.save_info.type == 2){
                  that.gold_card_balance = res.result.gold_card_balance
                }
                setTimeout(() => {
                  that.$router.push({
                    name: "GiftBoxList",
                    query: { state: 1 },
                  });
                }, 1000);
              }
            })
            .catch(function (error) {
              Toast(error.message);
            });
        }
      });
    },
  },
};
</script>
<style>
.toast-multiline {
  white-space: pre-line;
}
</style>
<style lang="scss" scoped>
.gold-w{
  font-size:14px;
  text-align: center;
  width: 100%;
  padding-top:20px;
  text-decoration: underline;
  color: #ca9f14;
}
.btn1{
    width: 60%;
    height: 32px;
    background: #e2b72c;
    border-radius: 16px;
    line-height: 32px;
    font-size: 14px;
    text-align: center;
    color: #FFFFFF;
    margin: auto;
    text-decoration: underline;
}
.page {
  ::v-deep .flex-line {
    padding: 16px;
    align-items: flex-start;
    flex-direction: column;

    .left {
      .field-name {
        width: 10rem;
      }
    }

    .right {
      margin-top: 20px;
      width: 100%;
    }

    .field-line-right {
      background-color: RGBA(255, 232, 232, 1);
      width: 100%;
      padding: 24px 15px;
      border-radius: 15px;
      border: 1px solid #e67f54;
      justify-content: space-between;
    }

    .field-input {
      background: transparent;
      text-align: left;
    }
  }
}

.main-content {
  padding: 0 $pageSpace;
  margin-bottom: 50px;
}

.common-header-wrap {
  z-index: 10;
  position: fixed;
  top: 54px;
  width: 100%;

  .common-header {
    background-color: rgba(232, 9, 12, 0.6);
    color: #fff;
  }
}

.common-header {
  box-shadow: none;
}

.logo {
  position: fixed;
  top: 25px;
  left: 12px;
  z-index: 99;

  img {
    width: 3.5rem;
  }
}

.common-popup-content {
  padding: 0 $pageSpace;
  box-sizing: border-box;
}

.order-body {
  top: 98px;
  padding: 0px 0;
  overflow: auto;
  width: 100%;
  z-index: 0;
  height: 80vh;

  .texts {
    position: relative;
    
    .h2{
      position: absolute;
      top: 53%;
      left: 11%;
      font-size: 16px;
      color: #ab4e1a;
    }
    img {
      width: 100%;
      height: 148px;
    }
  }
  .desc {
    .container {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      padding: 0.25rem 0;
    }

    .title {
      width: 5rem;
      font-size: $subFontSize;
      color: #333;
      margin-left: 0.6rem;
    }

    .subtitle {
      flex: 1;
      margin-left: 1rem;
      margin-right: 0.6rem;
      color: $primaryColor;
      font-size: $subFontSize;
      text-align: right;
    }
  }
}

.order_state {
  background: $primaryColor;
  height: 3.5rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  i {
    color: #fff;
    font-size: 1.2rem;
    padding: 0 0.5rem;
  }

  span {
    font-size: $h2;
    color: #fff;
  }
}

.containers {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: stretch;
  background: transparent;
  border-bottom: 1px solid #e8eaed;
}

.photo {
  width: 4rem;
  height: 4rem;
  margin: 0.75rem 0.5rem 0.75rem 0.75rem;
  border: 1px solid #e8eaed;
  flex-basis: 4rem;
  flex-shrink: 0;
}

.right-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  padding: 0 0.75rem 0 0;
  width: 100%;
  overflow: hidden;

  .title {
    margin-top: 0.75rem;
    color: #333;
    font-size: $subFontSize;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .property {
    font-size: $fontSize;
    color: #7c7f88;
    padding-top: 0.5rem;
  }

  .desc-wrapper {
    height: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-top: 1rem;

    .price {
      color: $primaryColor;
      font-size: $h2;
      margin-left: 0;
    }

    .btn-list {
      display: flex;

      .default {
        margin: 0 0.1rem;
      }
    }

    .count {
      margin-top: 0.2rem;
      color: #7c7f88;
      font-size: $fontSize;
      margin: 0 0.5rem;
    }
  }
}

.address {
  height: 4.4rem;
  background-color: #fff;
  margin-bottom: 0.5rem;

  div {
    padding: 0.5rem 0.5rem 0;
  }

  img {
    height: 0.8rem;
  }

  span {
    color: #333;
    font-size: $h2;

    &.mobile {
      padding-left: 1rem;
    }
  }

  p {
    margin: 0.25rem 0.9rem 0.5rem 0.5rem;
    font-size: $subFontSize;
    color: #7c7f88;

    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
}

.contact {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 2.3rem;
  background-color: #fff;
  margin-top: 0.4rem;
  border-bottom: 1px solid #e8eaed;
  padding: 0 0.65rem;

  span {
    font-size: $fontSize;
    color: #333;
    padding-right: 0.3rem;
  }

  img {
    width: 0.6rem;
    height: 0.65rem;
  }
}

.detail {
  display: flex;
  flex-direction: column;
  font-size: $subFontSize;
  color: #7c7f88;
  background-color: #fff;
  margin: 0.4rem 0;
  box-sizing: border-box;

  .number {
    padding: 0.7rem 0.8rem;
    border-bottom: 1px solid #e8eaed;

    p {
      padding-top: 0.3rem;
      font-size: $subFontSize;
    }

    button {
      color: #7c7f88;
      height: 1rem;
      background-color: #fff;
      border: 1px solid #7c7f88;
      width: 2.7rem;
      height: 1rem;
      border-radius: 0.1rem;
      font-size: $subFontSize;
    }
  }

  .pay {
    border-bottom: 1px solid #e8eaed;
    padding: 0.7rem 0.8rem;
  }

  .givetime {
    padding: 0.7rem 0.8rem;
    font-size: $subFontSize;
  }

  input {
    background-color: #fff;
    border: 1px solid #7c7f88;
  }
}

.desc {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  padding-top: 0.6rem;
  box-sizing: border-box;
  margin-bottom: 4rem;

  .desc-item {
    flex: 1;
    margin-top: 0.5rem;
  }

  .amount {
    display: flex;
    justify-content: flex-end;
    font-size: $subFontSize;
    color: #333;
    padding-right: 0.75rem;
    border-top: 1px solid #e8eaed;
    margin-top: 0.6rem;
    height: 2.2rem;
    line-height: 2.2rem;

    span {
      font-size: $h2;
      color: $primaryColor;
    }
  }
}

.ship {
  margin-bottom: 0;
}

.order_store {
  background: #fff;
  height: 1rem;
  line-height: 1rem;
  padding: 0.5rem 0.8rem;
  border-bottom: 1px solid #f5f5f5;
}

.order_store span {
  color: #333;
  font-size: $subFontSize;
  font-weight: 600;
  float: left;
  margin: 0 0.4rem;
}

.order_store i.store {
  float: left;
}

.order_store i.more {
  float: left;
  font-size: $subFontSize;
}

.pickup-code {
  font-size: $fontSize;
  color: #fff;
}
</style>

<!-- 字体图标样式覆盖 -->
<style lang="scss">
.mint-toast-icon {
  font-size: 1.9rem;
}

button {
  padding: 0;
}

.ds-button-large {
  margin: 0 $pageSpace;
  background: linear-gradient(90deg, #e8090c 0%, #f3611e 100%);
  margin-bottom: 50px;
}
</style>
